import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Form, Input} from "antd";
import PerfInput from "../../../../../components/perf-input";
import ZoomableTextArea from "../../../../../components/zoomable-textarea";
import {connect} from "react-redux";
import {updateFieldsMappingSet} from "../actions";

const mapStateToProps = (state) => ({
    name: state.scenes.mappingHandler.mappingSet.wizard.name,
    description: state.scenes.mappingHandler.mappingSet.wizard.description,
    selectedMappingSet: state.scenes.mappingHandler.mappingSet.wizard.selectedMappingSet,
    mappingSets: state.scenes.mappingHandler.mappingSet.tree.mappingSets,
});

const mapPropsToFields = ({name, description}) => {
    return {
        name: Form.createFormField({value: name || ""}),
        description: Form.createFormField({value: description || ""}),
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateFields: (fields) => dispatch(updateFieldsMappingSet(fields))
    }
}

const onFieldsChange = ({updateFields}, fields) => updateFields(fields);

const MappingSetName = ({t, form, name, description, selectedMappingSet, mappingSets, entityId}) => {
    return (
        <div style={{minHeight: "50vh", display: "flex", alignItems: "center", justifyContent: "center"}}>
            <Form style={{minWidth: "70%"}}>
                <Form.Item
                    label={t('scenes.mappingHandler.MappingSet.wizard.steps.third.name')}
                    className="ant-form-item-required"
                    required
                    validateStatus={(!selectedMappingSet || !selectedMappingSet.entityId) && name && (mappingSets || []).map(item => item.name).includes(name) ? "warning" : null}
                    help={(!selectedMappingSet || !selectedMappingSet.entityId) && name && (mappingSets || []).map(item => item.name).includes(name) ? t("scenes.mappingHandler.MappingSet.wizard.steps.second.mappingNeedsToBeSavedAlert.nameAlreadyExists") : null}
                >
                    {form.getFieldDecorator('name')(
                        <PerfInput
                            Component={Input}
                            disabled={!!selectedMappingSet && !!selectedMappingSet.entityId}
                            title={name}
                        />
                    )}
                </Form.Item>
                <Form.Item
                    label={t('scenes.mappingHandler.MappingSet.wizard.steps.third.description')}>
                    {form.getFieldDecorator('description')(
                        <ZoomableTextArea 
                            title={description}
                            disabled={!!selectedMappingSet && !!selectedMappingSet.entityId}
                        />
                    )}
                </Form.Item>
            </Form>
        </div>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
    Form.create({mapPropsToFields, onFieldsChange}),
)(MappingSetName);